import styled from 'styled-components';
import { AiOutlineEye } from 'react-icons/ai';
import HeartSvg from '@src/assets/imgs/heart.svg';
import ShowSvg from '@src/assets/imgs/show.svg';
import { FaRegCommentDots } from 'react-icons/fa';
import {
  useCommunitySingleMutaion,
  useDeleteCommunity,
} from '@src/hooks/useCommunitys';
import { useCallback, useState } from 'react';
import { useRouter } from 'next/router';
import ConfirmModal from '@src/components/Organism/Modal/ConfirmModal';
import { useSetRecoilState } from 'recoil';
import { modalAtom } from '@src/recoils/atom/modal';
import { useBodyScrollLock } from '@src/hooks/useBodyScrollLock';
import ShareSvg from '@src/assets/imgs/share.svg';
import ShareBlackSvg from '@src/assets/imgs/shareBlack.svg';
import CommentSvg from '@src/assets/imgs/comment.svg';
import useToast from '@src/hooks/useToast';
import * as gtag from '@src/utils/gtag';
import { copyClipBoard } from '@src/utils/community';

type Props = {
  isDonation: boolean;
  community: any;
  isMine: boolean;
};
// TODO: 조회수 댓글 수 응원해요 적용
const DetailStatus = ({ isDonation, community, isMine }: Props) => {
  const { mutate: onLike } = useCommunitySingleMutaion(
    isDonation ? 'donation' : 'board',
    community?.uuid
  );
  const [showConfirm, setShowConfirm] = useState<boolean>(false);
  const router = useRouter();

  const type = router.pathname.startsWith('/community/board/detail')
    ? 'board'
    : 'donation';
  const { mutate: onDelete } = useDeleteCommunity(community?.uuid, type);

  const onEditPage = () => {
    if (router.pathname.startsWith('/community/board/detail')) {
      router.push(
        `/community/edit?type=board&category=${community?.category}&id=${router.query.id}`
      );
    }
    if (router.pathname.startsWith('/community/donation/detail')) {
      router.push(`/community/edit?type=donation&id=${router.query.id}`);
    }
  };
  const onConfirm = useCallback((value: boolean) => {
    setShowConfirm(value);
  }, []);
  const setModal = useSetRecoilState(modalAtom);
  const { lockScroll } = useBodyScrollLock();
  const { showToast } = useToast();
  return (
    <>
      {showConfirm && (
        <ConfirmModal
          title="게시글 삭제"
          content="정말로 삭제하시겠습니까?"
          onConfirm={onDelete}
          onClose={() => onConfirm(false)}
        />
      )}
      <FlexNotFirst>
        <FlexCenter>
          <StatusText
            onClick={(e) => {
              e.stopPropagation();
              onLike(community?.uuid);
            }}
          >
            <HeartIcon isActive={community?.liked} />
            <span>
              {isDonation
                ? `응원해요 ${community?.likesCount}`
                : `공감해요 ${community?.likeCount}`}
            </span>
          </StatusText>
          <StatusText>
            <CommentIcon />
            <span>
              댓글{' '}
              {router.pathname.includes('/post/')
                ? community?.repliesCount
                : community?.repliesCount}{' '}
            </span>
          </StatusText>
          <StatusText>
            <ViewIcon />
            <span>
              {router.pathname.includes('/post/')
                ? community?.hits
                : community?.hits}
              회
            </span>
          </StatusText>
          <StatusText
            onClick={(e) => {
              e.stopPropagation();
              showToast('info', `클립보드에 복사되었습니다.`);
              gtag.share('board');
              // TODO: 복사 url 오류 고치자.
              copyClipBoard(`${window.location.href}`);
            }}
          >
            <ShareBlackIcon />
            <span>공유</span>
          </StatusText>
        </FlexCenter>
        {isMine && (
          <FlexCenter>
            <StatusText onClick={onEditPage}>수정</StatusText>
            <StatusText
              onClick={() => {
                onConfirm(true);
              }}
            >
              삭제
            </StatusText>
          </FlexCenter>
        )}
      </FlexNotFirst>
      {/* {isDonation && !isMine && (
        <ChatShareButton
          onClick={() => {
            lockScroll();
            setModal({
              id: 'appDown',
              visible: true,
            });
          }}
        >
          채팅으로 도움주기
        </ChatShareButton>
      )} */}
    </>
  );
};

const ViewIcon = styled(ShowSvg)``;

const ShareBlackIcon = styled(ShareBlackSvg)``;

const HeartIcon = styled(({ isActive, ...props }) => <HeartSvg {...props} />)<{
  isActive: boolean;
}>`
  & > path {
    fill: ${({ theme, isActive }) =>
      isActive ? theme.commonColor.pink004 : theme.commonColor.white};
    stroke: ${({ theme, isActive }) =>
      isActive ? theme.commonColor.pink004 : theme.commonColor.gray005};
  }
`;

const CommentIcon = styled(CommentSvg)`
  & > path {
    fill: ${({ theme }) => theme.commonColor.gray005};
  }
`;

const StatusText = styled.div`
  font-weight: 400;
  font-size: 14px;
  color: ${({ theme }) => theme.commonColor.gray005};
  display: flex;
  align-items: center;
  > span {
    margin-left: 6px;
    font-family: 'Regular';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 171.429% */
    letter-spacing: -0.6px;
  }
  cursor: pointer;
`;

const FlexNotFirst = styled.div`
  display: flex;
  justify-content: space-between;
  div:not(:first-child) {
    margin-left: 8px;
  }
  width: 100%;
`;

const FlexCenter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ChatShareButton = styled.button`
  box-shadow: 2px 1px 14px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  background-color: ${({ theme }) => theme.commonColor.white};
  color: ${({ theme }) => theme.commonColor.pink004};
  border: 1px solid ${({ theme }) => theme.commonColor.pink004};
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: -0.03em;
  width: 200px;
  cursor: pointer;
`;

export default DetailStatus;
